module.exports = __webpack_public_path__ + "themes/fq/sprite/win-sign@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/win-sign@2x.png
// module id = 76
// module chunks = d-game